import type { FC } from 'react'
import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { Image } from '@/components/ui'
import { JournalGtmClickEventPayload } from '@/pages/Journal/gtmConstants'
import { openArticleClicked } from '@/pages/Journal/gtmHelpers'
import { getJournalPublicationUrl } from '@/utils/infoportal/helpers'
import type { IJournalTagItemProps } from './types'
import './styles.scss'

const JournalTagItem: FC<IJournalTagItemProps> = props => {
  const { newsItem, isFirst } = props

  const { title, subtitle, slug, coverImage, showCover } = newsItem

  return (
    <article key={slug} className="journalTagItemCard" onClick={openArticleClicked(JournalGtmClickEventPayload.listArticles)}>
      <CommonLink url={getJournalPublicationUrl(slug)} className="journalTagItemCard__link">
        <div className="journalTagItemCard__textWrapper">
          <h4 className="journalTagItemCard__title">{title}</h4>

          {subtitle && <p>{subtitle}</p>}
        </div>

        {isFirst && showCover && <Image src={coverImage?.squareCover} isBackground className="journalTagItemCard__previewImage" />}
      </CommonLink>
    </article>
  )
}

export default JournalTagItem
